import IState from 'services/state';
import { ITypeformData } from './interfaces';

export const getForms = (state: IState): ITypeformData[] =>
  state.typeform.forms;
